import Service from "./common/services/Service";
const service = new Service();

$(document).on('click', '.file-listing .delete-upload', (e) => {
  e.preventDefault();
  let url = $(e.currentTarget).data('url');
  $.ajax(url, {
    data: {
      authenticity_token: service.csrfToken()
    },
    method: 'post',
    success: (data, status, xhr) => {
      if (data.status == 'success') {
        console.log('success');
        $(e.currentTarget).closest('li').remove();
        console.log('lenght of lis', $('.uploads-list').find('li').length);
        if ($('.uploads-list').find('li').length < 1) {
          $('div.file-listing').find('h6').remove();
        }
      } else {
        console.log('error deleting attachment')
      }
    }
  });
});

